import type { LogLevel } from "remotion";

/** URL param that turns on Remotion's Player diagnostics (buffering, audio sync anchor, audio scheduling). */
export const REMOTION_LOG_LEVEL_PARAM = "remotionLogLevel";

const LOG_LEVELS = new Set<string>([
  "trace",
  "verbose",
  "info",
  "warn",
  "error",
] satisfies LogLevel[]);

export function remotionLogLevelFromSearch(search: string): LogLevel | null {
  const value = new URLSearchParams(search).get(REMOTION_LOG_LEVEL_PARAM);
  return value !== null && LOG_LEVELS.has(value) ? (value as LogLevel) : null;
}
